/**
 * Bang error code CHINH THUC cua 2Captcha API v2.
 * Nguon: https://2captcha.com/api-docs/error-codes (doi chieu 2026-07).
 *
 * Quy tac tuyet doi (muc 6.5 cua dac ta): KHONG che them code moi.
 * Client cu da xu ly san dung bang nay; them code la la lam hong tinh drop-in.
 */
export const TWO_CAPTCHA_ERRORS = {
    ERROR_KEY_DOES_NOT_EXIST: {
        errorId: 1,
        errorCode: 'ERROR_KEY_DOES_NOT_EXIST',
        errorDescription: 'Your API key is incorrect. Make sure you set the key correctly and copied it from the dashboard',
    },
    ERROR_NO_SLOT_AVAILABLE: {
        errorId: 2,
        errorCode: 'ERROR_NO_SLOT_AVAILABLE',
        errorDescription: 'Your bid is too low for the captcha you submit or the queue of your captchas is too long',
    },
    ERROR_ZERO_CAPTCHA_FILESIZE: {
        errorId: 3,
        errorCode: 'ERROR_ZERO_CAPTCHA_FILESIZE',
        errorDescription: 'Image size is less than 100 bytes',
    },
    ERROR_TOO_BIG_CAPTCHA_FILESIZE: {
        errorId: 4,
        errorCode: 'ERROR_TOO_BIG_CAPTCHA_FILESIZE',
        errorDescription: 'Image size is more than 100 kB or image is bigger than 600px on any side',
    },
    ERROR_PAGEURL: {
        errorId: 5,
        errorCode: 'ERROR_PAGEURL',
        errorDescription: 'The value of websiteURL parameter is missing or has incorrect format',
    },
    ERROR_ZERO_BALANCE: {
        errorId: 10,
        errorCode: 'ERROR_ZERO_BALANCE',
        errorDescription: "You don't have funds on your account",
    },
    ERROR_IP_NOT_ALLOWED: {
        errorId: 11,
        errorCode: 'ERROR_IP_NOT_ALLOWED',
        errorDescription: 'The request is sent from the IP that is not on the list of your trusted IPs',
    },
    ERROR_CAPTCHA_UNSOLVABLE: {
        errorId: 12,
        errorCode: 'ERROR_CAPTCHA_UNSOLVABLE',
        errorDescription: 'Workers could not solve the Captcha',
    },
    ERROR_BAD_DUPLICATES: {
        errorId: 13,
        errorCode: 'ERROR_BAD_DUPLICATES',
        errorDescription: 'Error is returned when 100% accuracy feature is enabled. The error means that max numbers of tries is reached but min number of matches not found',
    },
    ERROR_NO_SUCH_METHOD: {
        errorId: 14,
        errorCode: 'ERROR_NO_SUCH_METHOD',
        errorDescription: 'Request made to API with a method that does not exist',
    },
    ERROR_IMAGE_TYPE_NOT_SUPPORTED: {
        errorId: 15,
        errorCode: 'ERROR_IMAGE_TYPE_NOT_SUPPORTED',
        errorDescription: 'The image can not be processed due to an incorrect format or size, or the image is corrupted. Please check the image',
    },
    ERROR_NO_SUCH_CAPCHA_ID: {
        errorId: 16,
        errorCode: 'ERROR_NO_SUCH_CAPCHA_ID',
        errorDescription: "You've provided incorrect captcha ID in the request",
    },
    ERROR_IP_BLOCKED: {
        errorId: 21,
        errorCode: 'ERROR_IP_BLOCKED',
        errorDescription: 'Your IP address is banned due to improper use of the API',
    },
    ERROR_TASK_ABSENT: {
        errorId: 22,
        errorCode: 'ERROR_TASK_ABSENT',
        errorDescription: 'task property is missing in your createTask method call',
    },
    ERROR_TASK_NOT_SUPPORTED: {
        errorId: 23,
        errorCode: 'ERROR_TASK_NOT_SUPPORTED',
        errorDescription: 'task property contains the type of task that is not supported by our API or the type was specified incorrectly',
    },
    ERROR_RECAPTCHA_INVALID_SITEKEY: {
        errorId: 31,
        errorCode: 'ERROR_RECAPTCHA_INVALID_SITEKEY',
        errorDescription: 'The sitekey value provided in your request is not valid',
    },
    ERROR_ACCOUNT_SUSPENDED: {
        errorId: 55,
        errorCode: 'ERROR_ACCOUNT_SUSPENDED',
        errorDescription: 'Your API access was blocked for improper use of the API',
    },
    ERROR_BAD_PARAMETERS: {
        errorId: 110,
        errorCode: 'ERROR_BAD_PARAMETERS',
        errorDescription: 'The required captcha parameters in your request are missing or have incorrect format',
    },
    ERROR_BAD_IMGINSTRUCTIONS: {
        errorId: 115,
        errorCode: 'ERROR_BAD_IMGINSTRUCTIONS',
        errorDescription: 'imgInstructions contains unsupported file type, corrupted file or the size of the image exceeds limits',
    },
    ERROR_BAD_PROXY: {
        errorId: 130,
        errorCode: 'ERROR_BAD_PROXY',
        errorDescription: 'Incorrect proxy parameters or can not establish connection through the proxy',
    },
};
/**
 * Ma loi dung khi khong giai duoc va upstream dang TAT.
 *
 * Luu y ve dac ta: ban PROMPT-PLAN goi loai nay la `ERROR_UNSOLVABLE`, nhung tai lieu
 * chinh thuc cua 2Captcha ghi la `ERROR_CAPTCHA_UNSOLVABLE` (errorId 12). Dac ta muc 6
 * quy dinh "neu tai lieu chinh thuc khac thi theo tai lieu chinh thuc", nen ta dung code that.
 */
export const UNSOLVABLE_ERROR_CODE = 'ERROR_CAPTCHA_UNSOLVABLE';
/** Dung response loi dung shape 2Captcha. `description` chi de ghi de khi can noi ro hon. */
export function twoCaptchaError(code, description) {
    const spec = TWO_CAPTCHA_ERRORS[code];
    return {
        errorId: spec.errorId,
        errorCode: spec.errorCode,
        errorDescription: description ?? spec.errorDescription,
    };
}
export function isTwoCaptchaErrorCode(value) {
    return Object.prototype.hasOwnProperty.call(TWO_CAPTCHA_ERRORS, value);
}
//# sourceMappingURL=errors.js.map